import { Field, ID, Int, ObjectType } from 'type-graphql'

@ObjectType()
export class ChatBatchFailure {
  @Field(() => ID)
  chatId: string

  @Field(() => String)
  reason: string
}

// Shared by all seven batch mutations — one result type serves every batch operation
// (`backend-action-style-guide.md` §2.3), rather than a per-operation Result class.
@ObjectType()
export class ChatBatchResult {
  @Field(() => Int)
  succeededCount: number

  @Field(() => Int)
  failedCount: number

  @Field(() => [ChatBatchFailure])
  failures: ChatBatchFailure[]
}
